<template>
  <div class="flex flex-col" data-cy="contract-signature-page">
    <div class="flex items-center gap-4 pb-4">
      <div class="flex flex-grow items-center justify-between gap-3">
        <MoleculeButton
          icon-name="ArrowLeftIcon"
          :label="t('common.previous')"
          iconPosition="left"
          size="xs"
          variant="secondary"
          @click.prevent="goToPreviousStep"
        />
        <AtomText
          :text="t('subscription.contractSignature.title')"
          class="hidden sm:block"
          data-cy="contract-signature-page-title"
        />
        <MoleculeTag
          :value="t('subscription.contractSignature.titleTag')"
          type="info"
          data-cy="contract-signature-page-tag"
        />
      </div>
    </div>

    <YouSign @update-you-sign-status="handleUpdateYouSignStatus" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { useStepStore, useToastSnackbarStore } from '@/stores';

import { YouSignResponseStatus } from '@/types/yousign.type';

import YouSign from '@/components/subscription/ContractSignature/YouSign.component.vue';

const { t } = useI18n();

const stepStore = useStepStore();
const { addErrorToast } = useToastSnackbarStore();
const { goToPreviousStep, goToNextStep } = stepStore;

const handleUpdateYouSignStatus = async (status: YouSignResponseStatus) => {
  if (status === YouSignResponseStatus.SUCCESS) {
    await goToNextStep();
    return;
  }

  addErrorToast({
    id: 'contract-signature-error',
    title: t('common.apiError'),
    content: t('subscription.contractSignature.api.errors.patchSubscriptionSignature'),
  });
};
</script>

<style scoped></style>
